import { useFieldHelper, FieldProps } from 'framework/ui/field';
import { Box } from '@mui/material';
import { MapedPoliciesDataType, PolicyStageBadgeField } from 'domain/shared/compliance';

const PoliciesStateField = ({ expanded }: FieldProps) => {
  const { getValue } = useFieldHelper<MapedPoliciesDataType[]>({ source: 'policies' });

  const policies = getValue() || [];
  const data = expanded ? policies : policies.slice(0, 2);

  return (
    <Box>
      {data.map(({ isPolicyAccepted, policyPath }) => {
        return (
          <Box key={policyPath} display="flex" alignItems="center" sx={{ minHeight: 24 }} mb="2px">
            <PolicyStageBadgeField value={isPolicyAccepted} />
          </Box>
        );
      })}
    </Box>
  );
};

export default PoliciesStateField;
